import Form from '@/found/components/form';
import request from '@/found/utils/request';
import { create } from 'sortablejs';
import companyList from './company_list.vue';
import productList from './product_list.vue';

formCreate.component('companyList', companyList);
formCreate.component('productList', productList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'price_maintenance_form',
      baseUnit: [],
    };
  },
  created() {
    this.getDict();
  },
  methods: {
    // 获取数据字典
    getDict() {
      //
      request.post('/mdm/mdmdictdata/list', {
        dictTypeCode: 'material_base_unit',
      }).then((res) => {
        if (!res.success) return this.$message.error(res.message);
        res.result.forEach((item) => {
          const data = item;
          data.key = item.dictCode;
          data.value = item.dictValue;
          return data;
        });
        this.baseUnit = res.result;
      });
    },
    // 设置rule
    setRule(item) {
      const v = item;

      if (v.field === 'productName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'product_list',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'companyName') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'company_list',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'startTime') {
        v.props = {
          ...v.props,
          'unlink-panels': true,
          type: 'datetimerange',
          'default-time': ['00:00:00', '23:59:59'],
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      const productName = this.getRule('productName');
      const companyName = this.getRule('companyName');
      //
      productName.on.change = (e) => {
        if (e && e.length > 0) {
          const row = this.baseUnit.filter((val) => val.key === e[0].saleUnit);
          this.setValue({
            productName: e[0].materialName,
            productCode: e[0].materialCode,
            productLevelCode: e[0].productLevelCode,
            productLevelName: e[0].productLevelName,
            unitConversion: e[0].unitConversion,
            spec: e[0].specification,
            saleUnit: e[0].saleUnit,
            saleUnitName: row[0]?.value,
          });
        } else {
          this.setValue({
            productCode: null,
            productName: null,
            unitConversion: null,
            spec: null,
            saleUnit: null,
            saleUnitName: null,
            productLevelCode: null,
            productLevelName: null,
          });
        }
      };
      // 公司主体
      companyName.on.change = (e) => {
        if (e && e.length > 0) {
          this.setValue({
            companyName: e[0].companyName,
            companyCode: e[0].companyCode,
          });
        } else {
          this.setValue({
            companyCode: null,
            companyName: null,
          });
        }
      };
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = '/dms/dmsterminalcontractproductconfing/save';
        const params = {
          ...formData,
          startTime: formData.startTime[0],
          endTime: formData.startTime[1],
        };

        if (this.formConfig.code === 'edit') {
          params.id = this.formConfig.row.id;
        }

        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
